import React from 'react';
import './NatureChart.css';

// Organized by increased stat, then decreased stat
const NATURES = [
  // Attack increasing natures
  { name: 'Adamant', increased: 'Attack', decreased: 'Sp. Atk' },
  { name: 'Lonely', increased: 'Attack', decreased: 'Defense' },
  { name: 'Naughty', increased: 'Attack', decreased: 'Sp. Def' },
  { name: 'Brave', increased: 'Attack', decreased: 'Speed' },
  
  // Defense increasing natures
  { name: 'Bold', increased: 'Defense', decreased: 'Attack' },
  { name: 'Impish', increased: 'Defense', decreased: 'Sp. Atk' },
  { name: 'Lax', increased: 'Defense', decreased: 'Sp. Def' },
  { name: 'Relaxed', increased: 'Defense', decreased: 'Speed' },
  
  // Speed increasing natures
  { name: 'Jolly', increased: 'Speed', decreased: 'Sp. Atk' },
  { name: 'Timid', increased: 'Speed', decreased: 'Attack' },
  { name: 'Hasty', increased: 'Speed', decreased: 'Defense' },
  { name: 'Naive', increased: 'Speed', decreased: 'Sp. Def' },
  
  // Special Attack increasing natures
  { name: 'Modest', increased: 'Sp. Atk', decreased: 'Attack' },
  { name: 'Mild', increased: 'Sp. Atk', decreased: 'Defense' },
  { name: 'Rash', increased: 'Sp. Atk', decreased: 'Sp. Def' },
  { name: 'Quiet', increased: 'Sp. Atk', decreased: 'Speed' },
  
  // Special Defense increasing natures
  { name: 'Calm', increased: 'Sp. Def', decreased: 'Attack' },
  { name: 'Gentle', increased: 'Sp. Def', decreased: 'Defense' },
  { name: 'Careful', increased: 'Sp. Def', decreased: 'Sp. Atk' },
  { name: 'Sassy', increased: 'Sp. Def', decreased: 'Speed' },
  
  // Neutral natures
  { name: 'Hardy', increased: null, decreased: null },
  { name: 'Docile', increased: null, decreased: null },
  { name: 'Serious', increased: null, decreased: null },
  { name: 'Bashful', increased: null, decreased: null },
  { name: 'Quirky', increased: null, decreased: null }
];

function NatureChart() {
  return (
    <div className="nature-chart-container">
      <h2>Nature Effects</h2>
      <div className="nature-chart-description">
        <p>Natures influence a Pokémon's stats by increasing one stat by 10% and decreasing another by 10%. 
           Neutral natures have no effect on stats.</p>
      </div>
      <div className="nature-chart-wrapper">
        <table className="nature-chart">
          <thead>
            <tr>
              <th>Nature</th>
              <th>Increased (+10%)</th>
              <th>Decreased (-10%)</th>
            </tr>
          </thead>
          <tbody>
            {NATURES.map(({ name, increased, decreased }) => (
              <tr key={name} className={!increased ? 'neutral-nature' : ''}>
                <td className="nature-name">{name}</td>
                <td className={`stat-cell ${increased ? 'increased' : ''}`}>
                  {increased || '—'}
                </td>
                <td className={`stat-cell ${decreased ? 'decreased' : ''}`}>
                  {decreased || '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default NatureChart; 